var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"24px"}},[_c('QS-h4-title',{attrs:{"title":"可租车辆"}}),_vm._v(" "),_c('QS-common-table',{attrs:{"max-height":400,"data":_vm.tableData.statDept,"columns":_vm.columns,"pagination":false,"span-method":_vm.objectSpanMethod}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }